import store from "@/redux/store";
import { v4 as uuid } from "uuid";

import {PersonModel as Person} from '@/models/PPC/Person';
import {WorkerModel as Worker} from '@/models/PPC/Worker';
import {CompanyModel as Company} from '@/models/PPC/Company';

import {Model} from "@/models/base/Model";
import {Collection} from "@/models/base/Collection";

export const PersonModel = Person;
export const WorkerModel = Worker;
export const CompanyModel = Company;

export class UserPersonCompanyService   {

    static getUPCData = (searchOn = null) => {
        const authReducer = store.getState().AuthReducer;
        
        let retVal = {data:null};
        if(searchOn === null) {
            retVal.data = authReducer.persons.merge(authReducer.companies, authReducer.users);
            
            //retVal.companies = authReducer.companies;
        }
        
        return retVal;
    }
    
}